import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts';
import AxiosPlugin from '@/utils/plugin/axios-plugin'
import VueI18n from 'vue-i18n'
import less from 'less'
import * as filters from './utils/filter'
import ExtendPrototype from './utils/ExtendPrototype'
import htmlToPdf from './utils/htmlToPdf'
import dedupeMessage from '../utils/message'
import JSEncrypt from "jsencrypt"; //引入模块


import enlocale from 'element-ui/lib/locale/lang/en'
import zhlocale from 'element-ui/lib/locale/lang/zh-CN'
// import 'font-awesome/css/font-awesome.min.css'
var locale = (localStorage.getItem('user_lang') == 'en' || Globals.DefaultLanguage == 'en') ? enlocale : zhlocale
Vue.use(less)
Vue.use(ElementUI, { locale, size: 'small' })
// 用去重版 $message 覆盖 Element 默认实现，避免同一条提示被弹两遍
Vue.prototype.$message = dedupeMessage
Vue.use(echarts)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(AxiosPlugin)
Vue.prototype.$baseConfig = Globals;
Vue.use(ExtendPrototype)
Vue.use(htmlToPdf)

Vue.use(VueI18n)
const i18n = new VueI18n({
  //locale: localStorage.getItem('user_lang') || 'zh', // 语言标识
  locale: localStorage.getItem('user_lang') || Globals.DefaultLanguage, // 语言标识
  messages: {
    'zh': require('../public/language/zh'),
    'en': require('../public/language/en')
  },
  silentTranslationWarn: true
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

import navigationBar from "../src/components/content/maintabber/navigationBar.vue";
Vue.component("nav-bar", navigationBar)

ElementUI.Dialog.props.closeOnClickModal.default = false; // 修改 el-dialog 默认点击遮照为不关闭

Vue.prototype.$jsEncrypt = JSEncrypt; //配置全局变量
